export default __webpack_public_path__ + "static/media/download (1).6d55d82c.svg";